import { Field, Form, FormikProvider, useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import styles from "./css/style.module.css";
import {
    Backdrop,
    CircularProgress,
    InputAdornment,
    makeStyles,
    TextField,
    useMediaQuery,
    useTheme,
} from "@material-ui/core";
import * as Yup from "yup";
import axios from "axios";
import { NODE_API_URL, LOGIN } from "./../../../../env_config";
import { Alert, Col, FormControl, Row } from "react-bootstrap";
import useTempMessage from "../../../../hooks/useTempMessage";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import useValidatedImage from "../../../../hooks/useValidatedImage";
import { LOGO_BASE_URL } from "../../../../env_config";
import { CiMail } from "react-icons/ci";
import { TbLockPassword } from "react-icons/tb";
import { toast } from "react-toastify";
import { SetCookies } from "../../../../_metronic/_helpers/Cookies";
import { actions } from "./../../../../app/modules/Auth/_redux/authRedux";
import { useDispatch } from "react-redux";
import { useDomain } from "../../../../contexts/DomainContext";
import { useLanguage } from "../../../../contexts/LanguageContext";

const initialValues = {
    email: "",
    password: "",
    confirmpassword: "",
    otp: "",
    mailsent: false,
    otpverified: false,
};

const ForgotPassword = () => {
    const language = useLanguage();
    const theme = useTheme();
    const isXsDown = useMediaQuery(theme.breakpoints.down("xs"));

    const { origin } = useDomain();

    const Schema = Yup.object().shape({
        email: Yup.string()
            .email(language.CCMODE_VALIDATION_EMAIL_INVALID)
            .required(language.CCMODE_AUTH_EMAIL_ADDRESS_IS_REQUIRED),
        password: Yup.string()
            .required(language.CCMODE_AUTH_PASSWORD_IS_REQUIRED)
            .matches(
                /^(?=.*[a-z])/,
                language.CCMODE_AUTH_PASSWORD_LOWERCASE
            )
            .matches(
                /^(?=.*[A-Z])/,
                language.CCMODE_AUTH_PASSWORD_UPPERCASE
            )
            .matches(/^(?=.*[0-9])/, language.CCMODE_AUTH_PASSWORD_NUMBER)
            .matches(
                /^(?=.*[!@#$%^&*])/,
                language.CCMODE_AUTH_PASSWORD_SPECIAL_CHAR
            )
            .min(8, language.CCMODE_AUTH_PASSWORD_MIN_8),
        confirmpassword: Yup.string()
            .oneOf([Yup.ref("password"), null], language.CCMODE_AUTH_PASSWORD_MUST_MATCH)
            .required(language.CCMODE_AUTH_CONFIRM_PASSWORD_IS_REQUIRED),
        otp: Yup.string()
            .required(language.CCMODE_AUTH_OTP_IS_REQUIRED)
            .length(6, language.CCMODE_AUTH_OTP_EXACTLY_6_DIGITS),
    });

    const history = useHistory();
    const dispatch = useDispatch();
    const [openLoader, setOpenLoader] = useState(false);
    const [error, setError] = useState("");
    const [otp, setOtp] = useState(new Array(6).fill(""));
    const [timer, setTimer] = useState(0);
    const [otptimer, setOtpTimer] = useState(0);
    const [tempMessage, setTempMessage] = useTempMessage();
    const inputRefs = useRef([]);

    const logo = localStorage.getItem("logo");
    const backgroundImg = localStorage.getItem("backgroundImg");
    const backgroundColor = localStorage.getItem("backgroundColor");
    const nav_bar_color = localStorage.getItem("nav_bar_color");
    const nav_bar_font = localStorage.getItem("nav_bar_font");

    const remoteLogoImageUrl = `${LOGO_BASE_URL}/${encodeURIComponent(logo || "")}`;

    let defaultImageUrl = require("./Images/ccmode_login_bg2.png");

    const remoteBgImageUrl = `${LOGO_BASE_URL}/${encodeURIComponent(
        backgroundImg || ""
    )}`;

    const logoUrl = useValidatedImage({ remoteUrl: remoteLogoImageUrl });
    const bgUrl = useValidatedImage({
        remoteUrl: remoteBgImageUrl,
        defaultUrl: defaultImageUrl,
    });

    const useStyles = makeStyles((theme) => ({
        backdrop: {
            zIndex: theme.zIndex.drawer + 1,
            color: "#fff",
        },
        link: {
            color: "rgb(0, 123, 255) !important",
        },
        otpInput: {
            fontSize: "15px",
            fontWeight: "bold",
        },
        validateOtpBtn: {
            width: "12rem !important",
        },
        resetPassBtn: {
            width: "14rem !important",
        },
        bg: {
            backgroundImage: `url('${bgUrl.imageUrl}')`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            height: "100%",
            backgroundPosition: "center center",
            backgroundColor: backgroundColor || "#EEF0F8",
        },
        forgotContainer: {
            width: "100vw",
            height: "100vh",
            display: "flex",

            [theme.breakpoints.down("xs")]: {
                flexDirection: "column",
            },
        },
        forgotForm: {
            backgroundColor: nav_bar_color || "#F4F6FC",

            [theme.breakpoints.down("xs")]: {
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%,-50%)",
                width: "90%",
                height: "65%",
                borderRadius: "15px",
                backgroundColor: nav_bar_color || "rgba(244, 246, 252, 0.8)",
            },
        },
        textColor: {
            color: nav_bar_font || "#616161",
        },
        textField: {
            "& .MuiInputBase-input": {
                color: `#000 !important`,
            },
            backgroundColor: "#fff !important",
            "& .MuiInput-underline:before, & .MuiInput-underline:active:not(.Mui-focused):before, & .MuiInput-underline:hover:not(.Mui-disabled):before, & .MuiInput-underline:after": {
                borderBottom: "none !important",
            },
            "& input:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 1000px #ffffff inset !important",
                WebkitTextFillColor: `#000 !important`,
            },
            [theme.breakpoints.down("xs")]: {
                "& .MuiInputBase-input": {
                    fontSize: "16px !important",
                },
            },
        },
        bgWhite: {
            backgroundColor: "#fff !important",
        },
        newLoginBtn: {
            width: "10rem",
            height: "auto",
            position: "relative",
            display: "inline-block",
            cursor: "pointer",
            outline: "none",
            border: 0,
            verticalAlign: "middle",
            textDecoration: "none",
            background: "transparent",
            padding: 0,
            fontSize: "inherit",
            fontFamily: "inherit",

            "& .circle": {
                transition: "all 0.45s cubic-bezier(0.65, 0, 0.076, 1)",
                position: "relative",
                display: "block",
                margin: 0,
                width: "3rem",
                height: "3rem",
                background: backgroundColor || `linear-gradient(90deg, rgba(0,164,245,1) 0%, rgba(0,76,200,1) 100%) !important`,
                borderRadius: "1.625rem",
            },

            "& .circle .icon": {
                transition: "all 0.45s cubic-bezier(0.65, 0, 0.076, 1)",
                position: "absolute",
                top: 0,
                bottom: 0,
                margin: "auto",
                background: "#fff",
            },

            "& .circle .icon.arrow": {
                left: "0.625rem",
                width: "1.125rem",
                height: "0.125rem",
                background: "none",
            },

            "& .circle .icon.arrow::before": {
                content: '""',
                position: "absolute",
                top: "-0.25rem",
                right: "0.0625rem",
                width: "0.625rem",
                height: "0.625rem",
                borderTop: `0.125rem solid ${nav_bar_font || "#fff"}`,
                borderRight: `0.125rem solid ${nav_bar_font || "#fff"}`,
                transform: "rotate(45deg)",
            },

            "& .button_text": {
                transition: "all 0.45s cubic-bezier(0.65, 0, 0.076, 1)",
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                padding: "0.75rem 0",
                margin: "0 0 0 1rem",
                fontWeight: 500,
                lineHeight: 1.6,
                textAlign: "center",
                textTransform: "uppercase",
                color: nav_bar_font || "#616161",
            },

            "&:hover .circle": {
                width: "100%",
            },

            "&:hover .circle .icon.arrow": {
                background: nav_bar_font || "#fff",
                transform: "translate(1rem, 0)",
            },

            "&:hover .button_text": {
                color: "#fff",
            },

            [theme.breakpoints.down("xs")]: {
                "& .circle": {
                    width: "100%",
                },
                "& .circle .icon.arrow": {
                    background: nav_bar_font || "#fff",
                    transform: "translate(1rem, 0)",
                },

                "& .button_text": {
                    color: nav_bar_font || "#fff",
                },
            },
        },
        otpRow: {
            [theme.breakpoints.down("xs")]: {
                gap: "10px",
            },
        },
    }));
    const classes = useStyles();

    const enableLoading = () => {
        setOpenLoader(true);
    };
    const disableLoading = () => {
        setOpenLoader(false);
    };

    const getInputClasses = (fieldname) => {
        if (formik.touched[fieldname] && formik.errors[fieldname]) {
            return "is-invalid";
        }

        if (formik.touched[fieldname] && !formik.errors[fieldname]) {
            return "is-valid";
        }

        return "";
    };

    const formik = useFormik({
        initialValues,
        validationSchema: Schema,
        onSubmit: (values, { setSubmitting }) => {
            enableLoading();
            axios({
                method: "POST",
                url: `${NODE_API_URL}/ccmode/reset-password`,
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json",
                },
                data: {
                    email: values.email,
                    password: values.password,
                    confirmPassword: values.confirmpassword,
                    otp: values.otp,
                },
            })
                .then((res) => {
                    if (res && res.data) {
                        disableLoading();
                        setSubmitting(false);
                        if (!res.data.success) {
                            setError(res.data.message);
                        }
                        setTempMessage(res.data.message);
                        setError("");
                        toast.dismiss();
                        toast.success(res.data.message);
                        // history.push("/auth");
                        axios({
                            method: "POST",
                            url: LOGIN,
                            headers: {
                                "Access-Control-Allow-Origin": "*",
                                "Content-Type": "application/json",
                            },
                            data: {
                                mail: values.email,
                                password: values.password,
                                client: origin,
                            },
                        })
                            .then(function(res) {
                                if (res && res.data) {
                                    const user = JSON.stringify(
                                        res.data.Customer[0]
                                    );
                                    const accessToken = res.data.accessToken;
                                    localStorage.setItem("userData", user);
                                    localStorage.setItem("C_id", -1);
                                    SetCookies("resData", user);
                                    localStorage.setItem(
                                        "accessToken",
                                        res.data.accessToken
                                    );
                                    dispatch(actions.login(accessToken));
                                    dispatch(actions.setUser(user));
                                    history.push("/searchdiamond");
                                }
                            })
                            .catch((res) => {
                                history.push("/auth");
                            });
                    }
                })
                .catch((error) => {
                    disableLoading();
                    setSubmitting(false);
                    if (error?.response?.data?.message) {
                        setError(error?.response?.data?.message);
                    }
                });
        },
    });

    const SendMail = () => {
        formik.validateField("email");
        if (formik.errors.email) {
            return;
        }
        enableLoading();
        axios({
            method: "POST",
            url: `${NODE_API_URL}/ccmode/forgot-password`,
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
            },
            data: {
                email: formik.values.email,
            },
        })
            .then((res) => {
                if (res && res.data) {
                    disableLoading();
                    if (!res.data.success) {
                        setError(res.data.message);
                    } else {
                        setError("");
                        setTempMessage(res.data.message);
                        setTimer(30);
                        setOtpTimer(300);
                        formik.setFieldValue("mailsent", true);
                    }
                }
            })
            .catch((error) => {
                disableLoading();
                if (error?.response?.data?.message) {
                    setError(error?.response?.data?.message);
                }
            });
    };

    const validateOtp = () => {
        formik.validateField("otp");
        if (formik.errors.otp) {
            return;
        }
        enableLoading();
        axios({
            method: "POST",
            url: `${NODE_API_URL}/ccmode/validate-otp`,
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
            },
            data: {
                email: formik.values.email,
                otp: formik.values.otp,
            },
        })
            .then((res) => {
                if (res && res.data) {
                    disableLoading();
                    if (!res.data.success) {
                        setError(res.data.message);
                    } else {
                        setError("");
                        setTempMessage(res.data.message);
                        formik.setFieldValue("otpverified", true);
                    }
                }
            })
            .catch((error) => {
                disableLoading();
                if (error?.response?.data?.message) {
                    setError(error?.response?.data?.message);
                }
            });
    };

    useEffect(() => {
        const countdown = setInterval(() => {
            if (timer > 0) {
                setTimer(timer - 1);
            }
        }, 1000);

        return () => clearInterval(countdown);
    }, [timer]);

    useEffect(() => {
        const otpcountdown = setInterval(() => {
            if (otptimer > 0) {
                setOtpTimer(otptimer - 1);
            }
        }, 1000);
        return () => clearInterval(otpcountdown);
    }, [otptimer]);

    const handleOtpChange = (element, index) => {
        if (isNaN(element.value)) return;

        const newOtp = [...otp];
        newOtp[index] = element.value;
        setOtp(newOtp);
        formik.setFieldValue("otp", newOtp.join(""));
        if (element.value && index < otp.length - 1) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            if (otp[index] === "") {
                if (index > 0) {
                    inputRefs.current[index - 1].focus();
                }
            } else {
                const newOtp = [...otp];
                newOtp[index] = "";
                setOtp(newOtp);
                formik.setFieldValue("otp", newOtp.join(""));
            }
        }
    };

    let screen = "sendEmail";
    if (formik.values.mailsent && !formik.values.otpverified) {
        screen = "enterOtp";
    } else if (formik.values.mailsent && formik.values.otpverified) {
        screen = "resetPassword";
    }

    const SendEmailScreen = (
        <div className={`${classes.forgotContainer} col-12 px-0`}>
            <div
                className={`${classes.bg} ${isXsDown ? "col-12" : "col-8"}`}
            ></div>
            <div
                className={`${classes.forgotForm} ${
                    isXsDown ? "col-12" : "col-4"
                } d-flex flex-center`}
            >
                <div className={`${isXsDown ? "col-12" : "col-10"}`}>
                    {logoUrl.isValid ? (
                        <div className="text-center mb-6">
                            <img
                                alt="Logo"
                                src={logoUrl.imageUrl}
                                height="76px"
                                style={{
                                    maxWidth: "200px",
                                    objectFit: "contain",
                                }}
                            />
                        </div>
                    ) : (
                        ""
                    )}
                    <div className="row">
                        <div className="text-center ">
                            {error && <Alert variant="danger"> {error} </Alert>}
                            <h3 className={`${classes.textColor} font-size-h1`}>
                                {language.CCMODE_AUTH_PASSWORD_RESET}
                            </h3>
                            <p
                                className={`${classes.textColor} font-weight-bold`}
                            >
                                {language.CCMODE_AUTH_FORGOT_PASSWORD_INSTRUCTIONS}
                                <br />
                                <b> {language.CCMODE_AUTH_OTP_VALID_5_MINUTES}</b>
                            </p>
                        </div>
                        <div className="col-12">
                            <Col md="12">
                                <Field
                                    className={`form-control form-control-solid h-auto py-3 px-6 ${getInputClasses(
                                        "email"
                                    )} ${classes.textField}`}
                                    type="email"
                                    name="email"
                                    placeholder="example@domain.com"
                                    as={TextField}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment
                                                position="start"
                                                color="#fff"
                                                style={{
                                                    padding: "8px",
                                                    margin: "0",
                                                }}
                                            >
                                                <CiMail
                                                    color="#0261CC"
                                                    size={18}
                                                />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                {formik.errors.email ? (
                                    <div className="invalid-feedback">
                                        {formik.errors.email}
                                    </div>
                                ) : null}
                            </Col>
                            <Col md="12" className="mt-6 text-center">
                                <button
                                    type="button"
                                    className={`${classes.newLoginBtn} submit`}
                                    onClick={() => SendMail()}
                                >
                                    <span
                                        className={`circle`}
                                        aria-hidden="true"
                                    >
                                        <span className={`icon arrow`}></span>
                                    </span>
                                    <span className={`button_text ml-8`}>
                                        {language.CCMODE_AUTH_SEND_OTP}
                                    </span>
                                </button>
                            </Col>
                            <Col md="12" className="mt-2 text-center">
                                <Link
                                    to="/auth"
                                    style={{
                                        color: nav_bar_font || "#007bff",
                                        textDecoration: "none",
                                        textTransform: "capitalize",
                                        fontSize: "14px",
                                    }}
                                >
                                    {language.CCMODE_AUTH_BACK_TO_LOGIN}
                                </Link>
                            </Col>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    const EnterOtpScreen = (
        <div className={`${classes.forgotContainer} col-12 px-0`}>
            <div
                className={`${classes.bg} ${isXsDown ? "col-12" : "col-8"}`}
            ></div>
            <div
                className={`${classes.forgotForm} ${
                    isXsDown ? "col-12" : "col-4"
                } d-flex flex-center`}
            >
                <div className={`${isXsDown ? "col-12" : "col-10"}`}>
                    {logoUrl.isValid ? (
                        <div className="text-center mb-6">
                            <img
                                alt="Logo"
                                src={logoUrl.imageUrl}
                                height="76px"
                            />
                        </div>
                    ) : (
                        ""
                    )}
                    <div className="row">
                        <div className="text-center m-auto">
                            {error && <Alert variant="danger">{error}</Alert>}
                            <h3 className={`font-size-h1 ${classes.textColor}`}>
                                {language.CCMODE_AUTH_RESET_YOUR_PASSWORD}
                            </h3>
                            {otptimer ? (
                                <>
                                    <div className="text-center font-weight-bold text-success">
                                        {language.CCMODE_AUTH_OTP_SENT_SUCCESSFULLY}
                                    </div>
                                    <p
                                        className={`${classes.textColor} font-weight-bold mb-5`}
                                    >
                                        {language.CCMODE_AUTH_OTP_SENT_TO} <br />
                                        <span className="text-warning font-weight-bold">
                                            {formik.values.email}
                                        </span>
                                        .<br /> {language.CCMODE_AUTH_ENTER_CODE_TO_PROCEED}
                                    </p>
                                </>
                            ) : (
                                ""
                            )}
                        </div>
                        <div className="col-12">
                            <Col md="12">
                                <div className="text-center mb-3">
                                    {!otptimer ? (
                                        ""
                                    ) : (
                                        <span
                                            className={`${classes.textColor} small`}
                                        >
                                            {language.CCMODE_AUTH_OTP_EXPIRES_IN}{" "}
                                            <span className="text-danger">{`${Math.floor(
                                                otptimer / 60
                                            )
                                                .toString()
                                                .padStart(2, "0")}:${(
                                                otptimer % 60
                                            )
                                                .toString()
                                                .padStart(2, "0")}`}</span>
                                        </span>
                                    )}
                                </div>
                                <Row
                                    className={`mb-3 ${
                                        classes.otpRow
                                    } ${getInputClasses("otp")}`}
                                >
                                    {otp.map((data, index) => (
                                        <Col
                                            className={isXsDown ? "p-0" : ""}
                                            key={index}
                                        >
                                            <FormControl
                                                type="text"
                                                name="otp"
                                                maxLength="1"
                                                value={data}
                                                onChange={(e) =>
                                                    handleOtpChange(
                                                        e.target,
                                                        index
                                                    )
                                                }
                                                onKeyDown={(e) =>
                                                    handleKeyDown(e, index)
                                                }
                                                onFocus={(e) =>
                                                    e.target.select()
                                                }
                                                ref={(el) =>
                                                    (inputRefs.current[
                                                        index
                                                    ] = el)
                                                }
                                                className={`text-center form-control form-control-solid font-size-h5 font-weight-bolder p-1 ${classes.otpInput} ${classes.bgWhite}`}
                                            />
                                        </Col>
                                    ))}
                                </Row>
                                <div className="col-12 d-flex justify-content-between px-0">
                                    <div className="text-danger small">
                                        {formik.errors.otp
                                            ? formik.errors.otp
                                            : null}
                                    </div>
                                    <div className="text-center">
                                        {!timer ? (
                                            <span
                                                className={`small ${classes.textColor}`}
                                            >
                                                {language.CCMODE_AUTH_DIDNT_GET_OTP}{" "}
                                                <span
                                                    className={`text-primary cursor-pointer ${classes.link}`}
                                                    onClick={() => SendMail()}
                                                >
                                                    {language.CCMODE_AUTH_REGENERATE_OTP}{" "}
                                                </span>
                                            </span>
                                        ) : (
                                            <span
                                                className={`${classes.textColor} small`}
                                            >
                                                {language.CCMODE_AUTH_REQUEST_NEW_OTP_IN}{" "}
                                                <span className="text-danger">{`00:${timer
                                                    .toString()
                                                    .padStart(2, "0")}`}</span>
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <Col md="12" className="mt-4 text-center">
                                    <button
                                        type="button"
                                        className={`${classes.newLoginBtn} submit ${classes.validateOtpBtn}`}
                                        onClick={() => validateOtp()}
                                    >
                                        <span
                                            className={`circle`}
                                            aria-hidden="true"
                                        >
                                            <span
                                                className={`icon arrow`}
                                            ></span>
                                        </span>
                                        <span className={`button_text ml-8`}>
                                            {language.CCMODE_AUTH_VALIDATE_OTP}
                                        </span>
                                    </button>
                                </Col>
                                <Col md="12" className="mt-4 text-center">
                                    <Link
                                        to="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            formik.setFieldValue(
                                                "mailsent",
                                                false
                                            );
                                        }}
                                        style={{
                                            color: "#007bff",
                                            textDecoration: "none",
                                            textTransform: "capitalize",
                                            fontSize: "14px",
                                        }}
                                    >
                                        {language.CCMODE_AUTH_RE_ENTER_EMAIL}
                                    </Link>
                                </Col>
                            </Col>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    const ResetPasswordScreen = (
        <div className={`${classes.forgotContainer} col-12 px-0`}>
            <div
                className={`${classes.bg} ${isXsDown ? "col-12" : "col-8"}`}
            ></div>
            <div
                className={`${classes.forgotForm} ${
                    isXsDown ? "col-12" : "col-4"
                } d-flex flex-center`}
            >
                <div className={`${isXsDown ? "col-12" : "col-10"}`}>
                    {logoUrl.isValid ? (
                        <div className="text-center mb-6">
                            <img
                                alt="Logo"
                                src={logoUrl.imageUrl}
                                height="76px"
                            />
                        </div>
                    ) : (
                        ""
                    )}
                    <div className="row justify-content-center">
                        <div className="text-center">
                            {tempMessage && (
                                <Alert variant="success">{tempMessage}</Alert>
                            )}
                            {error && <Alert variant="danger">{error}</Alert>}

                            <h3 className={`font-size-h1 ${classes.textColor}`}>
                                {language.CCMODE_AUTH_RESET_YOUR_PASSWORD_LOWER}
                            </h3>
                            <p
                                className={`${classes.textColor} font-weight-bold`}
                            >
                                {language.CCMODE_AUTH_ENTER_NEW_PASSWORD_BELOW}
                            </p>
                        </div>
                        <div className="col-12">
                            <div className="sum_tab mb-4">
                                <Field
                                    className={`form-control form-control-solid h-auto py-3 px-6 ${getInputClasses(
                                        "password"
                                    )} ${classes.textField}`}
                                    type="password"
                                    name="password"
                                    placeholder={language.CCMODE_AUTH_ENTER_PASSWORD}
                                    autoComplete="off"
                                    as={TextField}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment
                                                position="start"
                                                color="#fff"
                                                style={{
                                                    padding: "8px",
                                                    margin: "0",
                                                }}
                                            >
                                                <TbLockPassword
                                                    color="#0261CC"
                                                    size={18}
                                                />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                {formik.errors.password ? (
                                    <div className="invalid-feedback">
                                        {formik.errors.password}
                                    </div>
                                ) : null}
                            </div>
                            <div className="sum_tab mb-4">
                                <Field
                                    className={`form-control form-control-solid h-auto py-3 px-6 ${getInputClasses(
                                        "confirmpassword"
                                    )} ${classes.textField}`}
                                    type="password"
                                    name="confirmpassword"
                                    placeholder={language.CCMODE_AUTH_CONFIRM_YOUR_PASSWORD}
                                    autoComplete="off"
                                    as={TextField}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment
                                                position="start"
                                                color="#fff"
                                                style={{
                                                    padding: "8px",
                                                    margin: "0",
                                                }}
                                            >
                                                <TbLockPassword
                                                    color="#0261CC"
                                                    size={18}
                                                />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                {formik.errors.confirmpassword ? (
                                    <div className="invalid-feedback">
                                        {formik.errors.confirmpassword}
                                    </div>
                                ) : null}
                            </div>
                            <div className="text-center">
                                <button
                                    type="submit"
                                    className={`${classes.newLoginBtn} submit ${classes.resetPassBtn}`}
                                >
                                    <span
                                        className={`circle`}
                                        aria-hidden="true"
                                    >
                                        <span className={`icon arrow`}></span>
                                    </span>
                                    <span className={`button_text ml-10`}>
                                        {language.CCMODE_AUTH_RESET_PASSWORD}
                                    </span>
                                </button>
                            </div>
                            <div
                                className={`col-12 text-center text-sm mt-6 ${
                                    isXsDown ? "" : "text-muted"
                                }`}
                            >
                                {language.CCMODE_AUTH_DO_NOT_REFRESH_NOTE}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    const renderScreen = () => {
        if (screen === "sendEmail") {
            return SendEmailScreen;
        } else if (screen === "enterOtp") {
            return EnterOtpScreen;
        } else if (screen === "resetPassword") {
            return ResetPasswordScreen;
        }
    };

    return (
        <>
            <Backdrop className={classes.backdrop} open={openLoader}>
                <div className="px-5 py-3 bg-white rounded shadow-sm d-flex justify-content-center align-items-center">
                    <CircularProgress size="30px" color="secondary" />{" "}
                    <span className="pl-2 font-weight-bold text-dark">
                        {language.CCMODE_AUTH_PROCESSING}
                    </span>
                </div>
            </Backdrop>
            <FormikProvider value={formik}>
                <Form
                    className={`${styles.web_login} ${classes.bg}`}
                    id="kt_login_signin_form"
                    onSubmit={formik.handleSubmit}
                >
                    {renderScreen()}
                </Form>
            </FormikProvider>
        </>
    );
};

export default ForgotPassword;
